import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cj9aq68jgc: FaireBrandEntity = {
  token: "b_cj9aq68jgc",
  type: "brand",
  name: "ARTEAO Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/eca8878d35913f3abda7e1090c9f06cf204c9c7ec83271ab2e29f339959930e6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e38c1a87b120ba9b880b7347e9ecb9261705c9ce4cf2329a6e6a00cb40f51612.png",
  logoUrl:
    "https://cdn.faire.com/fastly/eca8878d35913f3abda7e1090c9f06cf204c9c7ec83271ab2e29f339959930e6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e38c1a87b120ba9b880b7347e9ecb9261705c9ce4cf2329a6e6a00cb40f51612.png",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "ARTEAO is a lifestyle brand that seeks the best quality, certified organic and natural products to inspire people. \n\nAll of our products are made by small farmers or craftmans who keep tradition.\n\nWe are happy and proud to introduce these high quality products to the world.",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:28:42.010Z",
    importedBy: "entity-db-cli",
  },
};
